import React from 'react';
import { graphql, useStaticQuery } from "gatsby"
import { makeStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';
import LightGallery from "./LightGallery";
import './LightGalleryStyle.scss';


const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const getImgURLs = (galleryImageObject) => {
  return galleryImageObject.node.images.map(item => item.file.url) 
}


function TabPanel(props) {
  const { children, value, index } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`gallery-tabpanel-${index}`}
      aria-labelledby={`gallery-tab-${index}`}
    >
      {value === index && <div>{children}</div>}
    </div>
  )
}

export default function GalleryTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const data = useStaticQuery(graphql`
        query {
            allContentfulGallery (sort: { fields: [categoryName], order: ASC }) {
                edges {
                    node {
                        categoryName
                        images {
                            title
                            file {
                                url
                            }
                        }
                    }
                }
            }
        }
    `)
    
    const [app, drnk, int, main] = data.allContentfulGallery.edges

    const getImgData = (galleryImageObject) => {
      return galleryImageObject.node.images.map(item => ({
        url: item.file.url,
        title: item.title
      }))
    }

    const drinks = getImgData(drnk)
    const interior = getImgData(int)
    const mainDishes = getImgData(main)


  return (
    <section className="galleryPage" aria-label="Photo Gallery">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
          aria-label="Gallery categories"
        >
        <Tab label="Main Dishes" id="gallery-tab-0" aria-controls="gallery-tabpanel-0" />
        {/* <Tab label="Appetizers" /> */}
        <Tab label="Drinks" id="gallery-tab-1" aria-controls="gallery-tabpanel-1" />
        <Tab label="Interior" id="gallery-tab-2" aria-controls="gallery-tabpanel-2" />
      </Tabs>
      <div className="galleryPageCarouselContainer">
        <TabPanel value={value} index={0} >
          <LightGallery items={mainDishes}/>
        </TabPanel>

        {/* <TabPanel value={value} index={1}>
          <LightGallery items={appetizers}/>
        </TabPanel> */}

        <TabPanel value={value} index={1}>
          <LightGallery items={drinks}/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <LightGallery items={interior}/>
        </TabPanel>
      </div>
    </section>
  );
}
